<template>
  <UserProfileForm
    :showAccountStatus="canChangeAccountStatus"
    :canChangeAccountStatus="canChangeAccountStatus"
  />
</template>

<script>
import { mapGetters } from "vuex";
import UserProfileForm from "@/components/UserProfileForm.vue";

export default {
  name: "UserSettings",
  components: { UserProfileForm },
  computed: {
    ...mapGetters({ rights: "getRights" }),
    canChangeAccountStatus() {
      const viewer = this.$store.state.user;
      return viewer?.rights?.canChangeAccountStatus === true;
    },
  },
};
</script>